'use strict';

/**
 * Resolve the Auth0 access token for the current mount, applying a forced
 * cache-bypass when the publisher-switch reducer left the 'ut:forceTokenRefresh'
 * sessionStorage marker.
 *
 * Extracted from AppLayout's useEffect so it can be unit-tested independently
 * of the React component tree.
 *
 * @param {Function} getAccessTokenSilently - from useAuth0()
 * @returns {Promise<string>} resolved access token
 */
export async function resolveAccessToken(getAccessTokenSilently) {
    const forceRefresh = sessionStorage.getItem('ut:forceTokenRefresh') === '1';
    if (forceRefresh) {
        try {
            return await getAccessTokenSilently({cacheMode: 'off'});
        } catch (e) {
            // Silent-auth failure — fall back to the cached token so the app
            // can still render.  The stale claim will expire naturally.
            return await getAccessTokenSilently();
        } finally {
            sessionStorage.removeItem('ut:forceTokenRefresh');
        }
    }
    return getAccessTokenSilently();
}
